import React, { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import {
	AUTH_PREFIX_PATH,
	UNAUTHENTICATED_ENTRY,
	REDIRECT_URL_KEY
} from 'configs/AppConfig'
import { loadUser } from 'store/slices/authSlice';

const ProtectedRoute = () => {

	const { token, user } = useSelector(state => state.auth)
	const dispatch = useDispatch()
	const location = useLocation()

	useEffect(() => {
		if (token && !user) {
			dispatch(loadUser())
		}
	}, [token, user, dispatch])

	if (!token) {
		return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`} replace />;
	}

	return <Outlet />
}

export default ProtectedRoute
